import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage, SignInProviderConfig } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { navModule } from './modules/nav';
import {
  microsoftAuthApiRef,
  useApi,
  configApiRef,
} from '@backstage/core-plugin-api';

import { autoOnboardingModule } from './modules/autoOnboarding';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const entra = {
        id: 'azure-auth-provider',
        title: 'Entra',
        message: 'Sign in using Microsoft Entra',
        apiRef: microsoftAuthApiRef,
      };
      const providers: (SignInProviderConfig | 'guest')[] =
        configApi.getOptionalString('auth.environment') === 'development'
          ? ['guest', entra]
          : [entra];

      return <SignInPage {...props} auto providers={providers} />;
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
    autoOnboardingModule,
  ],
});
